import { render, staticRenderFns } from "./ModalHotAlertFilter.vue?vue&type=template&id=0bbe6514&"
import script from "./ModalHotAlertFilter.vue?vue&type=script&lang=js&"
export * from "./ModalHotAlertFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports